import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['combineOption',
    'seperateTaxesFeesOption',
    'combineLabel',
    'seperateLabels',
    'form',
    'seperateTaxFeesCheck',
    'headerText',
    'headerLengthCounter',
    'footerText',
    'footerLengthCounter'
  ];

  connect() {
    this.receiptHeaderTextCharacterCounter()
    this.receiptFooterTextCharacterCounter()

    this.seperateTaxesFeesOptionTargets.forEach(option => {
      if (option.checked === true && option.value === 'false') {
        this.showCombinelabel();
      }

      if (option.checked === true && option.value === 'true') {
        this.showSeparateLabels();
      }
    });
  }

  toggleCombineOption(event) {
    this.seperateTaxesFeesOptionTargets.forEach(option => {
      option.checked = false;
    });
    event.currentTarget.checked = true;
    if (event.currentTarget.value === 'false') {
      this.showCombinelabel();
      this.seperateTaxFeesCheckTarget.checked = false
    } else {
      this.showSeparateLabels();
      this.seperateTaxFeesCheckTarget.checked = true
    }
  }

  showCombinelabel() {
    this.seperateLabelsTarget.classList.add('hidden');
    this.combineLabelTarget.classList.remove('hidden');
  }

  showSeparateLabels() {
    this.seperateLabelsTarget.classList.remove('hidden');
    this.combineLabelTarget.classList.add('hidden');
  }

  submitForm(event) {
    event.preventDefault()
    this.seperateTaxesFeesOptionTargets.forEach(option => {
      option.remove()
    })
    this.formTarget.submit()
  }

  receiptHeaderTextCharacterCounter() {
    let length = this.headerTextTarget.value.length

    this.headerLengthCounterTarget.textContent = `${length} characters`
  }

  receiptFooterTextCharacterCounter() {
    let length = this.footerTextTarget.value.length

    this.footerLengthCounterTarget.textContent = `${length} characters`
  }
}
